import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useGetCertificadoEmpresaByID = () => {
  const [loadingGetCertificadoEmpresaById, setLoadingCreateCertificadoEmpresa] = useState(false);
  const [successGetCertificadoEmpresaById, setSuccessCreateCertificadoEmpresa] = useState(false);
  const [errorGetCertificadoEmpresaById, setErrorCreateCertificadoEmpresa] = useState(null);
  const [dataGetCertificadoEmpresaById, setDataCertificadoEmpresa] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  )



  //GET
  const getCertificadoEmpresaById = async (userId:string ,prestacionId: string, id: string, _cb?:(data:any)=>void) => {
    setLoadingCreateCertificadoEmpresa(true);
    setSuccessCreateCertificadoEmpresa(false);
    setErrorCreateCertificadoEmpresa(null);

    apiRecord.getCertificadoEmpresaItByID(userId, prestacionId, id).then((res: any) => {
      setLoadingCreateCertificadoEmpresa(false);
      setSuccessCreateCertificadoEmpresa(true);
      setDataCertificadoEmpresa(res.data);
      if (typeof _cb === "function") {
        _cb(res.data);
      }
      
    }).catch((err:any) => {
      console.log(err)
      setLoadingCreateCertificadoEmpresa(false);
      setErrorCreateCertificadoEmpresa(err)
    })
  }

  //UPDATE




  return {
    getCertificadoEmpresaById,
    loadingGetCertificadoEmpresaById,
    successGetCertificadoEmpresaById,
    errorGetCertificadoEmpresaById,
    dataGetCertificadoEmpresaById
  }

}

export default useGetCertificadoEmpresaByID;